import '@/assets/styles/app.scss'

import Vue from 'vue'
import App from './App'
import store from './store/'
import './registerServiceWorker'
import './vuetify'
import vueInsomnia from 'vue-insomnia'

Vue.config.productionTip = false

Vue.use(vueInsomnia)

// try {
//   navigator.wakeLock.request('screen');
//   console.log('Screen Wake Lock is active');
// } catch (err) {
//   console.error(err);
// }

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  beforeCreate () {
    this.$store.commit('initialiseStore')
  },
  render: h => h(App)
})
